import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import SendToApp, { SendToAppProps } from "web/react/components/send-to-app/send-to-app";
import LeadLink from "web/react/components/lead-link/lead-link";
import styles from "./send-to-app-with-tracked-link.css";

interface SendToAppWithTrackedLinkProps extends SendToAppProps {
    leadUrl: string;
    productId: string;
    reason: string;
}

export default function SendToAppWithTrackedLink({
    title,
    analyticsEventLabel,
    url,
    productImageURL,
    appDeepLinkURL,
    className,
    leadUrl,
    productId,
    reason,
    financialIncentiveWebviewToken,
    downloadCTA,
}: SendToAppWithTrackedLinkProps): JSX.Element {
    function beforeLeadLinkClicked(callbackFunction, event): void {
        analytics.event("send_to_app", "lead_clicked", analyticsEventLabel);
        callbackFunction(event);
    }
    downloadCTA = downloadCTA ? downloadCTA : gettext("app_download_large_banner.general.cta");
    return (
        <SendToApp
            title={title}
            analyticsEventLabel={analyticsEventLabel}
            url={url}
            productImageURL={productImageURL}
            downloadCTA={downloadCTA}
            className={className}
            appDeepLinkURL={appDeepLinkURL}
            financialIncentiveWebviewToken={financialIncentiveWebviewToken}
            extraContent={(): JSX.Element => {
                return (
                    <>
                        <div className={styles.orContainer}>
                            <span className={styles.or}>
                                {gettext("in_stock_product.or_separator")}
                            </span>
                        </div>
                        <LeadLink
                            href={leadUrl}
                            openInNewTab={true}
                            productId={productId}
                            reason={reason}
                            beforeOnClick={beforeLeadLinkClicked}
                        >
                            <span className={styles.continueOnRetailer}>
                                {gettext("general.continue_to_retailer.link")}
                            </span>
                        </LeadLink>
                    </>
                );
            }}
        />
    );
}
